import { StringOfMax1024Chars } from "./strings";
import { HasToJson, HasValidationSchema } from "./template-headers";
import * as yup from "yup";

export type MetaTemplateBody = MetaParameterlessBody | MetaNamedParametersBody | MetaPositionalParametersBody;

export class MetaParameterlessBody implements HasToJson, HasValidationSchema {
    constructor(public text: StringOfMax1024Chars = '' as StringOfMax1024Chars) {}
    type = "body"
    toJson() {
        return JSON.stringify({
            type: this.type,
            text: this.text
        })
    }
    parse(str: string) {
        return typeof str == 'object' ? str : JSON.parse(str) as { type: "body", text: StringOfMax1024Chars }
    }
    getValidationSchema() {
        return yup.object({
            text: yup.string().max(1024, 'A descrição deve possuir, no máximo, 1024 caracteres.').required('A descrição é obrigatória.')
        })
    }
}

export class MetaNamedParametersBody implements HasToJson, HasValidationSchema {
    constructor(public text: StringOfMax1024Chars = '' as StringOfMax1024Chars, public example_bodyTextNamedParams: { param_name: string, example: string }[] = []) {}
    type = "body"
    toJson() {
        return JSON.stringify({
            type: this.type,
            text: this.text,
            example: {
                body_text_named_params: this.example_bodyTextNamedParams
            }
        })
    }
    parse(str: string) {
        return JSON.parse(str) as { type: "body", text: StringOfMax1024Chars, example: { body_text_named_params: { param_name: string, example: string }[] } }
    }
    getValidationSchema() {
        return yup.object({
            text: yup.string().max(1024, 'A descrição deve possuir, no máximo, 1024 caracteres.').required('A descrição é obrigatória.'),
            example_bodyTextNamedParams: yup.array(yup.object({ 
                param_name: yup.string().required('O nome do parâmetro é obrigatório.'),
                example: yup.string().required('Um exemplo de uso do parâmetro é obrigatório.'),
            })).required('Os exemplos de uso dos parâmetros são obrigatórios.')
        })
    }
}

export class MetaPositionalParametersBody implements HasToJson, HasValidationSchema{
    constructor(public text: StringOfMax1024Chars = '' as StringOfMax1024Chars, public example_bodyText: string[] = []) {}
    type = "body"
    toJson() {
        return JSON.stringify({
            type: this.type,
            text: this.text,
            example: {
                body_text: this.example_bodyText
            }
        })
    }
    parse(str: string) {
        return JSON.parse(str) as { type: "body", text: StringOfMax1024Chars, example: { body_text: string[] } }
    }
    getValidationSchema() {
        return yup.object({
            text: yup.string().max(1024, 'A descrição deve possuir, no máximo, 1024 caracteres.').required('A descrição é obrigatória.')
        })
    }
}
